export type MachineLifecycleNotice = {
  title: string;
  body: string;
};

export function machineLifecycleGuidance(action: 'archive' | 'restore', machineName: string): MachineLifecycleNotice {
  if (action === 'archive') {
    return {
      title: 'Machine archived',
      body: `${machineName} is out of the active workspace and new activity is paused. Machine Memory, documents, conversations, investigations, and history are preserved. Restore it from Archived when your team is ready to resume work.`,
    };
  }
  return {
    title: 'Machine restored',
    body: `${machineName} is active again. Its existing Machine Memory and history are available where your team left them, and new work can resume.`,
  };
}
